import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously, signOut } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = process.env.REACT_APP_FIREBASE_API_KEY && {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = firebaseConfig ? initializeApp(firebaseConfig) : undefined;

const firebaseDb = getDatabase(
  firebaseApp,
  process.env.REACT_APP_FIREBASE_DATABASE_URL
);

const firebaseAuth = getAuth(firebaseApp);

const loginUser = () => signInAnonymously(firebaseAuth);
const logoutUser = () => signOut(firebaseAuth);

export { firebaseApp, firebaseDb, firebaseAuth, loginUser, logoutUser };
